function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 8.571,
  cy: 8.571,
  r: 7.821,
  transform: "translate(.428 .429)",
  stroke: "#97A6C5",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.327 17.387a.75.75 0 101.06-1.06l-1.06 1.06zM13.47 14.53l2.857 2.857 1.06-1.06-2.857-2.857-1.06 1.06z",
  fill: "#97A6C5"
});

var SvgIconSearch32 = function SvgIconSearch32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOC41NzE0MyIgY3k9IjguNTcxNDMiIHI9IjcuODIxNDMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNDI4NDY3IDAuNDI4NTg5KSIgc3Ryb2tlPSIjOTdBNkM1IiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cGF0aCBkPSJNMi4zMjY4MSAzLjM4NzQ3QzIuNjE5NzEgMy42ODAzNyAzLjA5NDU4IDMuNjgwMzcgMy4zODc0NyAzLjM4NzQ3QzMuNjgwMzcgMy4wOTQ1OCAzLjY4MDM3IDIuNjE5NzEgMy4zODc0NyAyLjMyNjgxTDIuMzI2ODEgMy4zODc0N1pNLTAuNTMwMzMgMC41MzAzM0wyLjMyNjgxIDMuMzg3NDdMMy4zODc0NyAyLjMyNjgxTDAuNTMwMzMgLTAuNTMwMzNMLTAuNTMwMzMgMC41MzAzM1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0IDE0KSIgZmlsbD0iIzk3QTZDNSIvPgo8L3N2Zz4K";
export { SvgIconSearch32 as ReactComponent };